import styled from 'styled-components';
import { asRem } from 'utils/asRem';
import { mediaQueries } from 'utils/Constants/Breakpoints';
import { DarkContentBox } from 'View/Component';
import { colors } from 'View/Theme';

export default styled(DarkContentBox)`
  position: relative;
  width: ${asRem(340)};
  min-height: ${asRem(340)};
  padding: ${asRem(40)} ${asRem(16)} ${asRem(140)};
  border-bottom-color: ${colors.sleep.red.c500};
  height: ${asRem(380)};
  text-align: center;
  margin-bottom: ${asRem(24)};

  ${mediaQueries.md} {
    height: ${asRem(477)};
    width: ${asRem(400)};
    padding: ${asRem(60)} ${asRem(22)} ${asRem(16)};
    margin-bottom: 0;
  }

  .price-label {
    margin-bottom: 0;
    font-family: 'Source Sans Pro';

    ${mediaQueries.md} {
      margin-bottom: ${asRem(4)};
    }
  }

  .box-badge {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: ${asRem(30)};
    line-height: ${asRem(30)};
    text-align: center;
    background-color: ${colors.sleep.red.c500};
    color: ${colors.sleep.beige.c100};
    font-family: 'Source Sans Pro';
    font-size: ${asRem(20)};
    letter-spacing: ${asRem(0.3)};
    border-top-left-radius: ${asRem(8)};
    border-top-right-radius: ${asRem(8)};
  }

  .mime-elements-paragraph {
    margin: 0;
  }

  .price-info-box {
    margin: ${asRem(5)} 0;
  }

  .mime-elements-button {
    width: ${asRem(200)} !important;
    min-width: auto;
    padding-left: 0;
    padding-right: 0;
    margin-top: 0;
    margin-top: -${asRem(15)};

    ${mediaQueries.md} {
      margin-top: -${asRem(10)};
    }

    ${mediaQueries.lg} {
      margin-top: ${asRem(10)};
    }
  }

  .sleeping-luna-image {
    width: ${asRem(150)};
    margin: -${asRem(10)} auto 0;

    ${mediaQueries.md} {
      width: ${asRem(200)};
      bottom: 0;
      margin-top: -${asRem(30)};
    }

    ${mediaQueries.lg} {
      width: ${asRem(220)};
      bottom: 0;
    }
  }
`;
